import { n8nClient } from '../n8nClient';

class N8nChatService {
  constructor() {
    this.baseURL = process.env.RAZZLE_RUNTIME_N8N_URL || '';
    this.webhookNotLoggedIn = process.env.RAZZLE_RUNTIME_WEBHOOK_N8N_CHAT_PARTNER_NOT_LOGIN || '';
    this.webhookLoggedIn = process.env.RAZZLE_RUNTIME_WEBHOOK_N8N_CHAT_PARTNER_LOGIN || '';
  }

  async sendMessage(chatInput, user = null, sessionId = null, paymentClient = false) {
    try {
      const isLoggedIn = !!user;
      const webhookPath = isLoggedIn ? this.webhookLoggedIn : this.webhookNotLoggedIn;

      const payload = {
        action: 'sendMessage',
        chatInput,
        sessionId,
        timestamp: new Date().toISOString(),
      };

      // Add user metadata if logged in
      if (isLoggedIn && user) {
        payload.metadata = {
          email: user?.email,
          firstName: user?.firstName,
          lastName: user?.lastName,
          company: user?.company?.displayName,
          paymentClient: paymentClient,
        };
      }

      // Use n8nClient to post to webhook
      const response = await n8nClient.post(webhookPath, payload, {
        skipAuth: true, // Skip auth for webhooks
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new N8nChatService();
